import React from 'react';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import { theme } from '../../Theme';
import CategoryHeaderLoadingState from '../../CategoryPage/CategoryHeaderLoadingState';
import {
  CategoryWithSidebarContainer,
  CategoryWithSidebarContent,
  CategoryWithSidebarInner
} from './CategoryWithSidebar';

const backgroundColor = theme.colors.grey200;

export default React.memo(function CategoryWithSidebarHeaderLoadingState({
  hasImage
}) {
  return (
    <CategoryWithSidebarContainer>
      <CategoryWithSidebarInner>
        {SidebarChildren => (
          <>
            <SidebarChildren>
              <LoadingLine
                color={backgroundColor}
                widthRem={14}
                randomizeWidthBy={2}
                heightPx={28}
                style={{ marginBottom: '2rem' }}
              />
              <LoadingLine
                color={backgroundColor}
                widthRem={12}
                randomizeWidthBy={2}
                count={16}
                heightPx={18}
                style={{ marginBottom: '1rem' }}
              />
            </SidebarChildren>
            <CategoryWithSidebarContent>
              <CategoryHeaderLoadingState hasImage={!hasImage} />
            </CategoryWithSidebarContent>
          </>
        )}
      </CategoryWithSidebarInner>
    </CategoryWithSidebarContainer>
  );
});
